<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs
        main-link="welcome"
        main=""
        :title="$t('newRFQRequest.yeniQiymtSorusu')"
      />

      <div v-if="requestType==='PQ'">
        <h4 class="mb-3">
          {{ $t('newRFQRequest.yeniQiymtSorusu') }}
        </h4>


        <div class="row">
          <div class="col-xl-6 ">
            <div
              class="card h-100 mb-0 cursor-pointer"
              @click.prevent="requestType = 'PQT'"
            >
              <div class="card-body">
                <div class="d-flex">
                  <div style="width: 80px;">
                    <img
                      src="@/assets/images/icons/request/pqt.png"
                      style="width: 50px;"
                      alt="width: 50px;"
                    >
                  </div>
                  <div class="w-100">
                    <h4>{{ $t('newRFQRequest.rfqKotirovka') }}</h4>
                    <p>
                      {{ $t('newRFQRequest.sorunuDahaDetallYaratmaqOlur') }} <br>
                      {{ $t('newRFQRequest.soruyaGlnTkliflrYalnzMddtBitndBilinir') }} <br>
                      {{ $t('newRFQRequest.tlbinizUyunTklifSistemTrfindnAvtomatikSeilir') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 ">
            <div
              class="card mb-0 h-100 cursor-pointer"
              @click.prevent="requestType = 'RFQ'"
            >
              <div class="card-body">
                <div class="d-flex">
                  <div style="width: 80px;">
                    <img
                      src="@/assets/images/icons/request/rfq.png"
                      style="width: 50px;"
                      alt="ararim"
                    >
                  </div>
                  <div class="w-100">
                    <h4>{{ $t('newRFQRequest.rfq') }}</h4>
                    <p>
                      {{ $t('newRFQRequest.soruyaGlnTkliflriSonTarixBitmdnDGrmkOlur') }} <br>
                      {{ $t('newRFQRequest.tlbinizUyunTklifZnzSeirsizSistemSemir') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <h4
          v-if="requestType==='PQT'"
          class="mb-5"
        >
          <a
            href="#"
            class="rounded-circle bg-white text-dark p-2 r-1x1 mr-2"
            @click.prevent="requestType='PQ'"
          >
            <i class="fa fa-arrow-left fa-fw" />
          </a>
          {{ $t('newRFQRequest.rfqKotirovkaSorusu') }}
        </h4>
        <h4
          v-else-if="requestType==='RFQ'"
          class="mb-5"
        >
          <a
            href="#"
            class="rounded-circle bg-white text-dark p-2 r-1x1 mr-2"
            @click.prevent="requestType='PQ'"
          >
            <i class="fa fa-arrow-left fa-fw" />
          </a>
          {{ $t('newRFQRequest.yeniRfq') }}
        </h4>

        <div
          v-if="requestType === 'RFQ'"
          class="mb-5"
        >
          <div class="d-flex justify-content-between align-items-center rounded bg-light shadow text-dark p-2 mb-3">
            <div class="p-2">
              <i class="fa fa-info-circle mr-2" />
              {{ $t('newRFQRequest.artqRfqSorularnExcelFaylVasitsilYaradaBilrsiniz') }}
            </div>

            <div>
              <a
                :href="`${mediaBase}/template/${$i18n.locale ?? ''}/SCC_RFQ_TEMPLATE.xlsx`"
                target="_blank"
                class="btn btn-sm p-1 btn-light bg-white shadow"
              >

                <span class="badge badge-success p-1 mr-1"><i class="fa fa-fw fa-file-excel-o" /></span>
                {{ $t('newRFQRequest.ablonFaylYkl') }}
              </a>
            </div>
          </div>
          <p>
            <button
              type="button"
              class="btn btn-sm btn-success"
              @click.prevent="selectExcel()"
            >
              <i class="fa fa-upload" />
              {{ $t('newRFQRequest.hazrFaylGeriYkl') }}
            </button>
          </p>
        </div>


        <input
          id="fileInput"
          ref="file"
          type="file"
          style="display: none"
          @change="setPhoto"
        >

        <input
          id="fileInputMultiple"
          ref="fileMultiple"
          type="file"
          style="display: none"
          multiple
          @change="setPhoto"
        >

        <input
          id="excelInput"
          ref="excelFile"
          type="file"
          style="display: none"
          accept=".xlsx,.xls"
          @change="setExcel"
        >
        <form @submit.prevent="createRequest">
          <div class="card shadow">
            <div class="card-body">
              <h4>
                {{ $t('newInfoRequest.sorunuzHansSahyAiddir') }}
              </h4>

              <p>
                {{ $t('newAUCRequest.sorununYaradarknFaliyytSahsiniSemkMtlqdirSizMaximu') }}
              </p>

              <div class="mt-3">
                <button
                  v-b-modal.modal-sector-selection
                  type="button"
                  class="btn btn-sm btn-light-primary"
                >
                  {{ $t('companyProfile.faliyytSahsiniSein') }}
                </button>
              </div>
              <hr v-if="requestSectors.length>0">
              <SelectedSectorView
                :sectors="requestSectors"
                :parent-id="0"
              />
              <hr>
              <h4>
                {{ $t("whereCountry") }}
              </h4>
              <div class="mt-3">
                <Multiselect
                  v-model="selectedCountry"
                  :options="countryOptions"
                  :multiple="true"
                  :placeholder="$t('selectCountry')"
                  :custom-label="customLabel"
                  class="form-control"
                />
              </div>
            </div>
          </div>


          <div class="card shadow">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <h4>{{ $t('newAUCRequest.soruDetallar') }}</h4>
                <button 
                  type="button" 
                  class="btn btn-sm btn-outline-danger" 
                  @click="clearFormData"
                >
                  {{ $t('detailedComparisonModal.resetOffers') }}
                </button>
              </div>
              <hr>

              <div class="mb-3">
                <label for="new_request_title">{{ $t('newInfoRequest.soruBal') }}</label>
                <b-form-input
                  id="new_request_title"
                  v-model="requestTitle"
                  type="text"
                  required
                />
              </div>

              <div class="mb-3">
                <label for="new_request_description">{{ $t('newInfoRequest.soruMtni') }}</label>
                <b-form-textarea
                  id="new_request_description"
                  v-model="requestDescription"
                  required
                  rows="4"
                />
                <div
                  v-if="requestDescription.length<20"
                  class="text-secondary mt-1"
                >
                  {{ $t('newAUCRequest.soruSpesifikasiyasNAz20SimvoldanIbartOlmaldr') }}
                </div>
              </div>


              <div class="row mb-3">
                <div class="col-md-4">
                  <label for="new_request_deadline">{{ $t('newRFQRequest.tklifNSonTarix') }}</label>
                  <DatePicker
                    v-model="requestDeadline"
                    mode="dateTime"
                    is24hr
                    :minute-increment="15"
                    :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                    :min-date="minDeadline"
                    :is-required="true"
                    :model-config="{type: 'string', mask: 'YYYY-MM-DD HH:mm:ss'}"
                  >
                    <template #default="{ inputValue, inputEvents }">
                      <input
                        type="text"
                        class="form-control "
                        :value="inputValue"
                        placeholder=""
                        required
                        v-on="inputEvents"
                      >
                    </template>
                  </DatePicker>
                </div>

                <div
                  v-if="requestType==='PQT'"
                  class="col-md-4"
                >
                  <label>{{ $t('newRFQRequest.qalibinElanOlunmaTarixi') }}</label>

                  <DatePicker
                    v-model="orderExtras.winnerDeadline"
                    mode="dateTime"
                    is24hr
                    :minute-increment="15"
                    :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                    :min-date="requestDeadline"
                    :is-required="true"
                    :model-config="{type: 'string', mask: 'YYYY-MM-DD HH:mm:ss'}"
                    @input="checkDeadline"
                  >
                    <template #default="{ inputValue, inputEvents }">
                      <input
                        type="text"
                        class="form-control "
                        :value="inputValue"
                        placeholder=""
                        required
                        v-on="inputEvents"
                      >
                    </template>
                  </DatePicker>
                  <div
                    v-if="errorMessage"
                    class="error-message"
                  >
                    {{ errorMessage }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="requestType === 'PQT'"
            class="card shadow "
          >
            <div class="card-body">
              <h4>{{ $t('newRFQRequest.ilkinZruriTlblr') }}</h4>
              <p class="mb-4">
                {{ $t('newRFQRequest.tdarknnDzgnQiymtVermsiNTlbinizBardMlumatTfsilatlQe') }}
              </p>
              <hr>
              <div class="mb-3">
                <label>{{ $t('newRFQRequest.valyuta') }}</label>
                <div class="row">
                  <div class="col-md-3">
                    <select
                      v-model="orderExtras.currency"
                      class="form-control"
                      min="1"
                      required
                    >
                      <option value="AZN">
                        {{ $t('newAUCRequest.azn') }}
                      </option>
                      <option value="USD">
                        {{ $t('newRFQRequest.usd') }}
                      </option>
                      <option value="EUR">
                        {{ $t('newRFQRequest.eur') }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4 d-flex align-items-center">
                    <div class="radio radio-primary d-inline-block">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          id="currencyRequiredYes"
                          v-model="orderExtras.currencyRequired"
                          type="radio"
                          name="currency"
                          class="custom-control-input"
                          value="true"
                          required
                        >
                        <label
                          class="custom-control-label"
                          for="currencyRequiredYes"
                        >{{ $t('pqtExtrasView.mtlq') }}</label>
                      </div>
                    </div>
                    <div class="radio radio-primary d-inline-block">
                      <div class="custom-control custom-radio custom-control-inline ml-3">
                        <input
                          id="currencyRequiredNo"
                          v-model="orderExtras.currencyRequired"
                          type="radio"
                          name="currency"
                          class="custom-control-input"
                          value="false"
                        >
                        <label
                          class="custom-control-label"
                          for="currencyRequiredNo"
                        >{{ $t('pqtExtrasView.arzuOlunan') }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <!-- Delivery Required? -->
                <label>{{ $t('newRFQRequest.atdrlma') }}</label>
                <div class="row">
                  <div class="col-md-3">
                    <div class="radio radio-primary">
                      <div class="custom-control custom-radio custom-control-inline ml-3">
                        <input
                          id="deliveryYes"
                          v-model="orderExtras.deliveryNeeded"
                          type="radio"
                          value="true"
                          class="custom-control-input"
                        >
                        <label
                          class="custom-control-label"
                          for="deliveryYes"
                        >
                          {{ $t('newRFQRequest.yes') }}
                        </label>
                      </div>
                    </div>
                    <div class="radio radio-primary">
                      <div class="custom-control custom-radio custom-control-inline ml-3">
                        <input
                          id="deliveryNo"
                          v-model="orderExtras.deliveryNeeded"
                          type="radio"
                          value="false"
                          class="custom-control-input"
                        >
                        <label
                          class="custom-control-label"
                          for="deliveryNo"
                        >
                          {{ $t('newRFQRequest.no') }}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="orderExtras.deliveryNeeded === 'true'"
                    class="col-md-4"
                  >
                    <div class="input-group">
                      <input
                        v-model="orderExtras.deliveryAddress"
                        type="text"
                        class="form-control"
                        :placeholder="$t('newRFQRequest.enterAddress')"
                        required
                      >
                      <button
                        class="btn btn-outline-secondary"
                        @click.prevent="$bvModal.show('modal-address-history')"
                      >
                        📜
                      </button>
                    </div>
                  </div>
                  <!-- Delivery Date Required? -->
                  <div
                    v-if="orderExtras.deliveryNeeded === 'true'"
                    class="col-md-4"
                  >
                    <label>{{ $t('newRFQRequest.deliveryTimeRequest') }}</label>
                    <div class="radio radio-primary">
                      <div class="custom-control custom-radio custom-control-inline ml-3">
                        <input
                          id="timeYes"
                          v-model="orderExtras.deliveryTimeNeeded"
                          type="radio"
                          value="true"
                          class="custom-control-input"
                        >
                        <label
                          class="custom-control-label"
                          for="timeYes"
                        >
                          {{ $t('newRFQRequest.lazmdr') }}
                        </label>
                      </div>
                    </div>
                    <div class="radio radio-primary ">
                      <div class="custom-control custom-radio custom-control-inline ml-3">
                        <input
                          id="timeNo"
                          v-model="orderExtras.deliveryTimeNeeded"
                          type="radio"
                          value="false"
                          class="custom-control-input"
                        >
                        <label
                          class="custom-control-label"
                          for="timeNo"
                        >
                          {{ $t('newRFQRequest.lazmDeyil') }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Address History Modal -->
                <b-modal
                  id="modal-address-history"
                  centered
                  footer-class="hidden"
                  size="lg"
                  :title="$t('newRFQRequest.selectAddress')"
                  scrollable
                  class="theme-modal"
                  @hidden="resetForm"
                >
                  <!-- Address List -->
                  <ul class="list-group">
                    <li
                      v-for="(address, index) in savedAddresses"
                      :key="address.id"
                      class="list-group-item d-flex justify-content-between align-items-center selectable-address"
                      @click="selectAddress(address)"
                    >
                      <!-- Address divi -->
                      <div>
                        {{ address.address }}
                      </div>
                      <!-- Düymələr -->
                      <div>
                        <b-button
                          variant="outline-secondary"
                          size="sm"
                          class="mr-2"
                          @click.stop="editAddress(address)"
                        >
                          ✏️
                        </b-button>
                        <b-button
                          variant="outline-danger"
                          size="sm"
                          @click.stop="deleteAddress(address.id)"
                        >
                          ❌
                        </b-button>
                      </div>
                    </li>
                  </ul>
                  <hr>
                  <!-- Add/Edit Form -->
                  <div>
                    <b-form @submit.prevent="handleSubmit">
                      <b-form-group :label="formMode === 'add' ? $t('newRFQRequest.addAddress') : $t('newRFQRequest.editAddress')">
                        <b-form-input
                          v-model="addressInput"
                          :placeholder="$t('newRFQRequest.enter')"
                        />
                      </b-form-group>

                      <b-button
                        variant="success"
                        type="submit"
                      >
                        {{ formMode === 'add' ? $t('newRFQRequest.create') : $t('newRFQRequest.update') }}
                      </b-button>
                      <b-button
                        v-if="formMode === 'edit'"
                        variant="secondary"
                        class="ml-2"
                        @click="resetForm"
                      >
                        Ləğv et
                      </b-button>
                    </b-form>
                  </div>
                </b-modal>
              </div>
              <hr>
              <div class="mb-3">
                <div class="row">
                  <div class="col-md-4">
                    <label>{{ $t('newRFQRequest.dniSulu') }}</label>
                    <div class="radio radio-primary">
                      <div class="custom-control custom-radio custom-control-inline ml-3">
                        <input
                          id="paymentRequiredYes"
                          v-model="orderExtras.paymentRequired"
                          type="radio"
                          name="payment"
                          class="custom-control-input"
                          value="true"
                          required
                        >
                        <label
                          class="custom-control-label"
                          for="paymentRequiredYes"
                        >{{ $t('newRFQRequest.yes') }}</label>
                      </div>
                    </div>
                    <div class="radio radio-primary ">
                      <div class="custom-control custom-radio custom-control-inline ml-3">
                        <input
                          id="paymentRequiredNo"
                          v-model="orderExtras.paymentRequired"
                          type="radio"
                          name="payment"
                          class="custom-control-input"
                          value="false"
                        >
                        <label
                          class="custom-control-label"
                          for="paymentRequiredNo"
                        >{{ $t('newRFQRequest.no') }}</label>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="orderExtras.paymentRequired === 'true'"
                    class="col-md-4"
                  >
                    <label>{{ $t('newRFQRequest.paymentRequirements') }}</label>
                    <div class="radio radio-primary">
                      <div class="custom-control custom-radio custom-control-inline ml-3">
                        <input
                          id="paymentRequirements30100"
                          type="radio"
                          disabled
                          name="paymentRequirements"
                          class="custom-control-input"
                          value="paymentRequirements30100"
                          required
                        >
                        <label
                          class="custom-control-label"
                          for="paymentRequirements30100"
                        >{{ $t("newRFQRequest.paymentRequirements30100") }}</label>
                      </div>
                    </div>
                    <div class="radio radio-primary ">
                      <div class="custom-control custom-radio custom-control-inline ml-3">
                        <input
                          id="paymentRequirements100"
                          type="radio"
                          name="paymentRequirements"
                          class="custom-control-input"
                          value="paymentRequirements100"
                          disabled
                        >
                        <label
                          class="custom-control-label"
                          for="paymentRequirements100"
                        >{{ $t("newRFQRequest.paymentRequirements100") }}</label>
                      </div>
                    </div>
                    <div class="radio radio-primary ">
                      <div class="custom-control custom-radio custom-control-inline ml-3">
                        <input
                          id="paymentRequirementsPercent"
                          type="radio"
                          name="paymentRequirements"
                          class="custom-control-input"
                          value="paymentRequirementsPercent"
                          disabled
                        >
                        <label
                          class="custom-control-label"
                          for="paymentRequirementsPercent"
                        >{{ $t('newRFQRequest.paymentRequirementsPercent') }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <div class="mb-3">
                <div class="row">
                  <div class="col-md-4">
                    <label>{{ $t('newRFQRequest.guarantyTime') }}</label>

                    <div class="radio radio-primary">
                      <div class="custom-control custom-radio custom-control-inline ml-3">
                        <input
                          id="guarantyTimeYes"
                          v-model="orderExtras.guarantyTime"
                          type="radio"
                          name="guarantyTime"
                          class="custom-control-input"
                          value="true"
                          required
                        >
                        <label
                          class="custom-control-label"
                          for="guarantyTimeYes"
                        >{{ $t('newRFQRequest.yes') }}</label>
                      </div>
                    </div>
                    <div class="radio radio-primary ">
                      <div class="custom-control custom-radio custom-control-inline ml-3">
                        <input
                          id="guarantyTimeNo"
                          v-model="orderExtras.guarantyTime"
                          type="radio"
                          name="guarantyTime"
                          class="custom-control-input"
                          value="false"
                        >
                        <label
                          class="custom-control-label"
                          for="guarantyTimeNo"
                        >{{ $t('newRFQRequest.no') }}</label>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-4"
                  >
                    <label>{{ $t('newRFQRequest.countryRequired') }}</label>
                    <div class="radio radio-primary">
                      <div class="custom-control custom-radio custom-control-inline ml-3">
                        <input
                          id="countryRequiredYes"
                          v-model="orderExtras.countryRequired"
                          type="radio"
                          name="countryRequired"
                          class="custom-control-input"
                          value="true"
                          required
                        >
                        <label
                          class="custom-control-label"
                          for="countryRequiredYes"
                        >{{ $t('newRFQRequest.yes') }}</label>
                      </div>
                    </div>
                    <div class="radio radio-primary ">
                      <div class="custom-control custom-radio custom-control-inline ml-3">
                        <input
                          id="countryRequiredNo"
                          v-model="orderExtras.countryRequired"
                          type="radio"
                          name="countryRequired"
                          class="custom-control-input"
                          value="false"
                        >
                        <label
                          class="custom-control-label"
                          for="countryRequiredNo"
                        >{{ $t("newRFQRequest.no") }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="mb-1">
                <label>{{ $t('newRFQRequest.ilkinZruriTlblrlBalQeydlr') }}</label>

                <div>
                  <textarea
                    v-model.trim="orderExtras.initialRequirementNotes"
                    class="form-control"
                    cols="5"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="card shadow">
            <div class="card-body">
              <div
                v-if=" requestType === 'PQT'"
                class="mb-3"
              >
                <label>{{ $t('newInfoRequest.lavFayllar') }}</label> <br>
                <p>{{ $t('newInfoRequest.sorunuzlaBalLavFayllarYklyBilrsiniz') }}</p>

                <div class="d-flex">
                  <button
                    type="button"
                    class="btn btn-sm btn-light-primary"
                    @click.prevent="selectPhoto(-1)"
                  >
                    {{ $t('newInfoRequest.yeniFaylYkl') }}
                  </button>
                  <div
                    v-if="uploadProgress >0 && uploadProgress <100"
                    class="progress"
                  >
                    <div
                      class="progress-bar progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      aria-valuenow="75"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      :style="{width: `${uploadProgress}%`}"
                    />
                  </div>
                </div>
                <div
                  v-if="requestFiles.length>0"
                  class="w-50 mt-3"
                >
                  <div
                    v-for="(f,i) in requestFiles"
                    :key="f.path"
                    class="requestFile py-1"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <a
                          :href="getPhoto(f.path,'')"
                          target="_blank"
                          class="text-secondary"
                        >
                          <i class="fa fa-paperclip mr-1" />
                          {{ f.path.split('/').pop() }}
                        </a>
                      </div>

                      <div
                        class="d-flex align-items-center cursor-pointer"
                        href="#"
                        @click="deleteFile(i)"
                      >
                        <feather
                          type="x"
                          size="16"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr>


              <div class="d-flex align-items-center flex-column flex-sm-row">
                <div class="checkbox checkbox-primary">
                  <b-form-checkbox
                    v-model="requestIsPrivate"
                    value="1"
                    :disabled="onlyVendors>0"
                  >
                    <div>
                      {{ $t('newAUCRequest.mllifiGizlt') }} <br>
                      <span
                        v-if="requestIsPrivate"
                        class="text-danger"
                      > {{ $t('newAUCRequest.mllifiDigrIstifadilrYalnzMzakiryBalayarsaGrcklr') }}</span>
                      <span
                        v-else
                        class="text-success"
                      >{{ $t('newAUCRequest.mllifiBtnIstifadilrGrcklr') }}  </span>
                    </div>
                  </b-form-checkbox>
                </div>
                <div
                  v-if="requestType === 'PQT'"
                  class="d-flex flex-column  mt-2 mt-sm-0 p-3"
                  style="margin-left: 16rem; !important; border: 1px solid #2062fb"
                >
                  <h4>{{ $t('newRFQRequest.kotirovkaMetodunuSein') }}</h4>
                  <div class="checkbox checkbox-primary">
                    <b-form-checkbox
                      v-model="autoWinner"
                      value="1"
                    >
                      {{ $t('newAUCRequest.manual') }}
                    </b-form-checkbox>
                  </div>
                  <div class="checkbox checkbox-primary mt-2">
                    <b-form-checkbox
                      v-model="autoWinner"
                      value="2"
                    >
                      {{ $t('newAUCRequest.automatic') }}
                    </b-form-checkbox>
                  </div>
                </div>
              </div>
              <div class=" d-flex align-items-center">
                <div class="checkbox checkbox-primary">
                  <b-form-checkbox
                    v-model="requestIsPersonalAllowed"
                    value="1"
                  >
                    {{ $t('newAUCRequest.frdiVensizXslrSorunuCavablayaBilsin') }}
                  </b-form-checkbox>
                </div>
                <div
                  v-if="requestType === 'PQT'"
                  class="d-flex flex-column  mt-2 mt-sm-0 p-3"
                  style="margin-left: 11rem;"
                >
                  <div class="checkbox checkbox-primary">
                    <b-form-checkbox
                      v-model="orderExtras.showBefore"
                      value="true"
                    >
                      {{ $t('newRFQRequest.showBefore') }}
                    </b-form-checkbox>
                  </div>
                  <div class="checkbox checkbox-primary mt-2">
                    <b-form-checkbox
                      v-model="orderExtras.alternativeRequired"
                      value="true"
                    >
                      {{ $t('newRFQRequest.alternativeOffer') }}
                    </b-form-checkbox>
                  </div>
                </div>
              </div>


              <b-modal
                id="modal-vendors"
                centered
                size="lg"
                :title="$t('vndrlrScn')"
                scrollable
                class="theme-modal"
              >
                <button
                  class="btn btn-primary btn-lg"
                  style="margin-bottom: 20px"
                  @click="selectAllVendors"
                >
                  {{ $t('selectAll') }}
                </button>
                <div
                  v-for="v in filteredVendors"
                  class="list-group-item"
                >
                  <div
                    :key="v.id"
                    class="row"
                  >
                    <div class="col-md-4 mb-3">
                      <strong>{{ v.verifiedCompany.name }} {{ getCompanyFormat(v.verifiedCompany.format) }}</strong>
                      <br>
                      {{ $t('supplierOutgoingVendorRequest.ven') }} <em>{{ v.verifiedCompany.taxId }}</em><br>
                    </div>
                    <!-- Adding sector names -->
                    <div class="col-md-12">
                      <strong>{{ $t('sektorlari') }} </strong>
                      <span
                        v-for="sectorObj in v.sectors"
                        :key="sectorObj.sector.id"
                      >
                        {{ sectorObj.sector.name }},
                      </span>
                    </div>

                    <div class="col-md-8 mb-3">
                      <div v-if="v.profileType==='LOGISTIC'">
                        {{ $t('companyVendors.logistikSorularNTsdiqlnmidir') }}
                      </div>

                      <div v-if="v.profileType==='TRUCK'">
                        {{ $t('companyVendors.trlarlaBalSorularNTsdiqlnmidir') }}
                      </div>
                    </div>
                    <div class="col-md-12">
                      {{
                        $t('companyVendors.vcreatedbynameVcreatedbysurnameTrfindnNewDatevlogt', {
                          name: v.createdBy.name,
                          surname: v.createdBy.surname,
                          time: getMoment(v.logTime)
                        })
                      }}
                    </div>
                    <b-form-checkbox
                      class="col-md-12 checkbox checkbox-primary"
                      :checked="isChecked(v.verifiedCompany.id)"
                      @change="toggleChecked(v.verifiedCompany.id)"
                    />
                  </div>
                </div>
                <template #modal-footer>
                  <div
                    v-if="missingSectors.length > 0"
                    class="alert alert-warning"
                  >
                    <strong>{{ $t('newRFQRequest.noVendorForThisSector') }}</strong>
                    <ul>
                      <li
                        v-for="sector in missingSectors"
                        :key="sector.id"
                      >
                        {{ sector.parent.name }}
                      </li>
                    </ul>
                    <strong>{{ $t('newRFQRequest.deleteThisSector') }}</strong>
                  </div>
                  <button
                    class="btn btn-secondary"
                    @click="closeModal"
                  >
                    {{ $t('conversationDetails.bala') }}
                  </button>
                </template>
              </b-modal>
              <div class=" d-flex align-items-center">
                <div class="checkbox checkbox-primary">
                  <b-form-checkbox
                    v-model="onlyVendors"
                    value="1"
                    :disabled="!vendorManagementAvailable || requestIsPrivate>0 || filteredVendors===0"
                    @change="openModal"
                  >
                    <p @click.prevent="openModal">
                      {{ $t('newInfoRequest.ancaqTsdiqlnmiTdarklrimCavablayaBilsin') }}
                      <span
                        v-if="selectedVendorCount > 0"
                        style="color: #1ea6ec"
                      >
                        {{ $t('vendorSeilib', {selectedVendorCount: selectedVendorCount}) }}
                      </span>
                    </p>
                    <em
                      v-if="showSectorError"
                      style="color: red"
                    >{{ $t('sorguNSektorSemmisiz') }}</em>
                    <em
                      v-if="filteredVendorsError"
                      style="color: red"
                    >{{ $t('newRFQRequest.noVendor2') }}</em>
                    <br>
                    <span
                      v-if="!vendorManagementAvailable"
                      class="text-danger"
                    >
                      {{ $t('newInfoRequest.buFunksiyanIstifadEtmkN') }}
                      <strong>{{ $t('newInfoRequest.vendorManagement') }}</strong>
                      {{ $t('newInfoRequest.lavsiniAktivldirmlisniz') }}
                      <router-link :to="{name: 'addOnPage'}">{{ $t('newInfoRequest.aktivldir') }}</router-link>
                    </span>
                    <span
                      v-if="requestIsPrivate>0"
                      class="text-danger"
                    >
                      {{ $t('newInfoRequest.gizliSorularNBuFunskiyaAktivDeyil') }}
                    </span>
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>


          <div class="card shadow">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <h4>{{ $t('newAUCRequest.mhsullar') }}</h4>
                <button
                  type="button"
                  class="btn btn-sm btn-light-primary"
                  @click.prevent="addNewProduct()"
                >
                  {{ $t('newAUCRequest.yeniMhsulLavEt') }}
                </button>
              </div>

              <hr>

              <table class="table table-bordernone product-table">
                <thead>
                  <tr>
                    <th>{{ $t('newAUCRequest.tip') }}</th>
                    <th>{{ $t('newRFQRequest.mhsulunXidmtinAd') }}</th>
                    <th>{{ $t('newAUCRequest.miqdar') }}</th>
                    <th>{{ $t('newRFQRequest.mhsulXidmtHaqqndaQeydlr') }}</th>
                    <th>{{ $t('newAUCRequest.lavFayl') }}</th>
                    <th>{{ $t('newAUCRequest.specialRequirements') }}</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(p, i) in products"
                    :key="i"
                  >
                    <td>
                      <span v-if="p.productType==='PRODUCT'">{{ $t('newAUCRequest.mhsul') }}</span>
                      <span v-else-if="p.productType==='SERVICE'">{{ $t('newAUCRequest.xidmt') }}</span>
                      <span v-else>{{ p.productType }}</span>
                    </td>
                    <td class="can-wrap">
                      {{ p.name }}
                    </td>
                    <td>{{ p.count }} {{ p.unit }}</td>
                    <td class="can-wrap">
                      {{ p.note }}
                    </td>
                    <td>
                      <span v-if="p.photos && p.photos.length > 0">
                        <span
                          v-for="(photo, photoIndex) in p.photos"
                          :key="photoIndex"
                        >
                          *.{{ photo.split('.').pop() }}{{ photoIndex < p.photos.length - 1 ? ', ' : '' }}
                        </span>
                      </span>
                      <span v-else-if="p.photo">*.{{ p.photo.split('.').pop() }}</span>
                      <span v-else>-</span>
                    </td>
                    <td class="can-wrap">
                      <ul>
                        <li
                          v-for="(req, index) in p.specialRequirements"
                          :key="`req-${index}`"
                        >
                          <span
                            v-if="req.mandatory"
                            class="text-danger"
                          >*</span>
                          {{ `${index + 1}. ` }}{{ req.text }}
                        </li>
                      </ul>
                    </td>
                    <td class="text-right">
                      <button
                        type="button"
                        class="btn btn-sm p-2 btn-light-success"
                        @click="editProduct(i)"
                      >
                        <feather
                          type="edit-3"
                          size="12"
                        />
                        {{ $t('newAUCRequest.dzliEt') }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm p-2 btn-light-danger ml-2"
                        @click="deleteProduct(i)"
                      >
                        <feather
                          type="x"
                          size="12"
                        />
                      </button>
                    </td>
                  </tr>
                  <tr
                    v-if="products.length < 1"
                    class="not-found"
                  >
                    <td colspan="7">
                      <div class="alert alert-warning">
                        {{ $t('newAUCRequest.mhsulLavEdilmyib') }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>


          <div class="m-2">
            <div v-if="requestType==='PQT'">
              <div class="checkbox checkbox-primary mb-3">
                <b-form-checkbox
                  v-model="rfqTerms"
                  value="1"
                  required
                >
                  <router-link
                    target="_blank"
                    :to="{path: '/dashboard/page/pqt_terms'}"
                  >
                    {{ $t('newRFQRequest.rfqKotirovkaQaydalarnQbulEdirm') }}
                  </router-link>
                </b-form-checkbox>
              </div>
            </div>

            <div v-else-if="requestType==='RFQ'">
              <div class="checkbox checkbox-primary mb-3">
                <b-form-checkbox
                  v-model="rfqTerms"
                  value="1"
                  required
                >
                  <router-link
                    target="_blank"
                    :to="{path: '/dashboard/page/rfq_terms'}"
                  >
                    {{ $t('newRFQRequest.rfqQiymtSorusuQaydalarnQbulEdirm') }}
                  </router-link>
                </b-form-checkbox>
              </div>
            </div>


            <button class="btn btn-lg btn-primary">
              {{ $t('newInfoRequest.sorunuYarat') }}
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- Container-fluid Ends-->

    <b-modal
      id="modal-sector-selection"
      centered
      :title="$t('companyProfile.faliyytSahsiniSein')"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="false"
      class="theme-modal"
      :busy="false"
      :hide-footer="true"
    >
      <sector_selection_modal
        :max-selection="5"
        :parent-sector="null"
        :selected="requestSectors"
        @done="sectorSelected($event)"
      />
    </b-modal>

    <b-modal
      id="modal-edit-product"
      size="xl"
      centered
      :title="$t('newAUCRequest.mhsul')"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="true"
      class="theme-modal"
      :hide-footer="true"
    >
      <form @submit.prevent="saveProduct">
        <div
          v-if="editingProductIndex>-1"
          class="card-body"
        >
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label>{{ $t('newAUCRequest.tip') }}</label>
                <select
                  v-model="editingProduct.productType"
                  class="form-control"
                  required
                >
                  <option value="PRODUCT">
                    {{ $t('newAUCRequest.mhsul') }}
                  </option>
                  <option value="SERVICE">
                    {{ $t('newAUCRequest.xidmt') }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label>{{ $t('newAUCRequest.mhsulunXidmtinAd') }}</label>
                <input
                  v-model="editingProduct.name"
                  class="form-control"
                  type="text"
                  required
                >
              </div>

              <div class="mb-3">
                <label>{{ $t('newAUCRequest.mhsulXidmtHaqqndaQeydlr') }}</label>
                <textarea
                  v-model="editingProduct.note"
                  class="form-control"
                  type="text"
                />
              </div>


              <div class="mb-3">
                <div class="row">
                  <div class="col-6">
                    <label>{{ $t('newAUCRequest.miqdar') }}</label>
                    <input
                      v-model="editingProduct.count"
                      class="form-control"
                      type="number"
                      step="1"
                      required
                    >
                  </div>
                  <div class="col-6">
                    <label>{{ $t('newAUCRequest.lVahidi') }}</label>
                    <select
                      v-if="editingProduct.productType==='SERVICE'"
                      v-model="editingProduct.unit"
                      class="form-control"
                      required
                    >
                      <option
                        v-for="v in serviceUnits"
                        :key="v"
                        :value="v"
                      >
                        {{ v }}
                      </option>
                    </select>
                    <select
                      v-else
                      v-model="editingProduct.unit"
                      class="form-control"
                      required
                    >
                      <option
                        v-for="v in productUnits"
                        :key="v"
                        :value="v"
                      >
                        {{ v }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <label>{{ $t('newAUCRequest.lavFayl') }}</label> <br>

              <div
                v-if="editingProduct.photos && editingProduct.photos.length > 0"
                class="d-flex flex-wrap"
              >
                <div
                  v-for="(photo, photoIndex) in editingProduct.photos"
                  :key="photoIndex"
                  class="mr-2 mb-2 position-relative"
                >
                  <img
                    v-if="isPhoto(photo)"
                    :src="getPhoto(photo,'mediumCropped')"
                    alt=""
                    class="img-thumbnail"
                    style="max-height: 150px; max-width: 150px;"
                  >
                  <div
                    v-else
                    class="p-3 border border-secondary rounded"
                    style="max-height: 150px; max-width: 150px;"
                  >
                    *.{{ photo.split('.').pop() }} {{
                      $t('newRFQRequest.editingproductphotosplitpopFayl')
                    }}
                  </div>
                  <button
                    type="button"
                    class="btn btn-sm btn-danger position-absolute"
                    style="top: 5px; right: 5px;"
                    @click.prevent="deleteProductPhoto(photoIndex)"
                  >
                    <i class="fa fa-times" />
                  </button>
                </div>
              </div>
              <div class="mt-2">
                <button
                  v-if="!editingProduct.photos || editingProduct.photos.length < 6"
                  type="button"
                  class="btn btn-sm mr-2 btn-light-primary"
                  @click.prevent="selectPhoto(1)"
                >
                  {{ $t('newAUCRequest.ykl') }} ({{ editingProduct.photos ? editingProduct.photos.length : 0 }}/6)
                </button>
                <br>
                <div v-if="requestType === 'PQT'">
                  <br>
                  <label>{{ $t('newAUCRequest.specialRequirements') }}</label>
                  <br>
                  <!-- Use the specialRequirements of the editingProduct -->
                  <div
                    v-for="(req, index) in editingProduct.specialRequirements"
                    :key="index"
                    class="mb-2"
                  >
                    <div class="input-group">
                      <input
                        v-model="req.text"
                        type="text"
                        class="form-control"
                        required
                        :placeholder="$t('newAUCRequest.enterSpecialRequirement')"
                      >
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-danger"
                          type="button"
                          @click="removeSpecialRequirementFromProduct(index)"
                        >
                          <i class="fa fa-trash" />
                        </button>
                        <div class="form-check d-flex align-items-center ml-3">
                          <input
                            v-model="req.mandatory"
                            class="form-check-input"
                            type="checkbox"
                          >
                          <label
                            class="form-check-label ml-2"
                          >
                            {{ $t('newRFQRequest.mandatoryReply') }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    v-if="editingProduct.specialRequirements?.length < 5"
                    type="button"
                    class="btn btn-outline-primary"
                    @click="addSpecialRequirementToProduct"
                  >
                    {{ $t('newAUCRequest.addSpecialRequirement') }}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12 d-flex justify-content-between">
              <button
                type="submit"
                class="btn btn-primary mr-3"
              >
                {{ $t('sectorSelectionModal.yaddaSaxla') }}
              </button>
              <button
                type="button"
                class="btn btn-light-danger"
                @click.prevent="cancelSaveProduct"
              >
                {{ $t('companyProfile.lvEt') }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>

import {mapState} from "vuex";
import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker';
import moment from "moment";
import dayjs from "dayjs";
import 'vue-multiselect/dist/vue-multiselect.min.css'

import {
  addAddressCompany,
  createRequest,
  createRequestFromExcel,
  deleteAddressCompany,
  getCompanyAddresses,
  getVendorManagementStatus,
  updateAddressCompany,
  upload
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "/src/repositories/Repository";
import persistForm from '@/mixin/persistForm'

import {deliveryTypes, getCompanyFormat, getPhoto, loadTypes} from "@/repositories/Utils";
import {getFormsBySectorIds, getVendorList} from "@/repositories/VendorManagementRepository";
import Sector_selection_modal from "@/components/sector_selection_modal.vue";
import Sector_path from "@/components/sector_path.vue";
import SelectedSectorView from "@/components/SelectedSectorsView.vue";

export default {
  components: {
    SelectedSectorView,
    Sector_path,
    Sector_selection_modal,
    Multiselect, Datepicker
  },
  mixins: [ persistForm ],
  data() {
    return {
      // formState içində deyil, komponentin işləməsi üçün lazımlılar:
      missingSectors: [],
      countryCodes: [],
      showSectorError: false,
      filteredVendorsError: false,
      allSelected: false,
      showVendors: false,
      mediaBase: mediaBase,
      faq: [],
      filteredVendors: [],
      sectors: [],
      forms: [],
      uploadProgress: 0,
      photoIndex: 0,
      vendors: [],
      editingProduct: null,
      editingProductIndex: -1,
      addressInput: "",
      formMode: "add",
      editAddressId: null,
      savedAddresses: [],
      format: "dd MMM yyyy",
      inctermsList: ["EXW","FOB","CIF","FCA","DPU","CFR","CIP","DAP","DDP"],
      typeList: deliveryTypes(),
      advTypeList: loadTypes(),
      productUnits: this.$t("productUnits"),
      serviceUnits: this.$t("serviceUnits"),
      loadUnits: this.$t("loadUnits"),
      pollAnswerList: [],
      vendorManagementAvailable: false,
      errorMessage: '',
    };
  }
  ,
  watch: {
    "$route"() {
      this.requestType = this.$route.query.type;
    },
    selectedCountry() {
      this.updateCountryCodes();
    },
    onlyVerified(newVal) {
      if (newVal) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.onlyVerifiedModalText"),
          icon: 'warning'
        })
      }
    },
    onlyVendors(newVal) {
      if (newVal===false){
        this.vendorIds = []
        return;
      }

      // if no sector selected show error msg
      if (this.requestSectors.length === 0) {
        this.showSectorError = true;
        return;
      } else if (this.filteredVendors.length === 0) {
        this.filteredVendorsError = true;
        return;
      }
      this.onlyVendors = newVal;
    } // onlyVendors
  },
  computed: {
    requestType: {
      get() { return this.formState.requestType },
      set(v) { this.formState.requestType = v }
    },
    requestTitle: {
      get() { return this.formState.requestTitle },
      set(v) { this.formState.requestTitle = v }
    },
    requestDescription: {
      get() { return this.formState.requestDescription },
      set(v) { this.formState.requestDescription = v }
    },
    requestSectors: {
      get() { return this.formState.requestSectors },
      set(v) { this.formState.requestSectors = v }
    },
    selectedCountry: {
      get() { return this.formState.selectedCountry },
      set(v) { this.formState.selectedCountry = v }
    },
    requestDeadline: {
      get() { return this.formState.requestDeadline },
      set(v) { this.formState.requestDeadline = v }
    },
    orderExtras: {
      get() { return this.formState.orderExtras },
      set(v) { this.formState.orderExtras = v }
    },
    products: {
      get() { return this.formState.products },
      set(v) { this.formState.products = v }
    },
    requestFiles: {
      get() { return this.formState.requestFiles },
      set(v) { this.formState.requestFiles = v }
    },
    requestIsPrivate: {
      get() { return this.formState.requestIsPrivate },
      set(v) { this.formState.requestIsPrivate = v }
    },
    requestIsPersonalAllowed: {
      get() { return this.formState.requestIsPersonalAllowed },
      set(v) { this.formState.requestIsPersonalAllowed = v }
    },
    onlyVerified: {
      get() { return this.formState.onlyVerified },
      set(v) { this.formState.onlyVerified = v }
    },
    onlyVendors: {
      get() { return this.formState.onlyVendors },
      set(v) { this.formState.onlyVendors = v }
    },
    rfqTerms: {
      get() { return this.formState.rfqTerms },
      set(v) { this.formState.rfqTerms = v }
    },
    autoWinner: {
      get() { return this.formState.autoWinner },
      set(v) { this.formState.autoWinner = v }
    },
    vendorIds: {
      get() { return this.formState.vendorIds },
      set(v) { this.formState.vendorIds = v }
    },
    countryOptions() {
      const countries = this.$t('countries'); // Fetches the countries translations based on the current locale
      return Object.keys(countries).map(code => {
        return `${countries[code]}`
        // The label that Vue Multiselect will display
      });
    },
    customLabel(option) {
      return option.code; // Assumes that each option is an object with a 'name' property
    },
    selectedVendorCount() {
      return this.vendorIds.length;
    },
    ...mapState({
      company: state => state.auth.company,
      token: state => state.auth.token,
      user: state => state.auth.user,
      profile: state => state.auth.profile,
    }),
    isChecked() {
      return (id) => this.vendorIds.includes(id);
    },
    minDeadline() {
      return dayjs().add(1, "day").format("YYYY-MM-D");
    }
  },
  mounted() {
    this.getVendorList();
    this.fetchAddresses();
    if (this.profile !== 'PROCUREMENT') {
      this.$router.push({name: 'changeAccount'});
    }
    getVendorManagementStatus(this.token).then(({code}) => {
      this.vendorManagementAvailable = (code === 200);
    })
  },
  methods: {
    clearFormData() {
      this.$swal({
        title: this.$t("generalModal.warningTitle"),
        text: this.$t("detailedComparisonModal.resetOffersDescription"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t("generalModal.yes"),
        cancelButtonText: this.$t("generalModal.no")
      }).then((result) => {
        if (result.isConfirmed) {
          // Reset formState to default values
          this.formState = {
            requestType: 'PQ',
            requestTitle: '',
            requestDescription: '',
            requestSectors: [],
            selectedCountry: [],
            requestDeadline: '',
            orderExtras: {
              currency: '',
              currencyRequired: '',
              deliveryNeeded: '',
              deliveryAddress: '',
              deliveryTimeNeeded: '',
              paymentRequired: '',
              guarantyTime: '',
              countryRequired: '',
              initialRequirementNotes: '',
            },
            products: [],
            requestFiles: [],
            requestIsPrivate: 0,
            requestIsPersonalAllowed: 0,
            onlyVerified: 0,
            onlyVendors: 0,
            rfqTerms: 0,
            autoWinner: null,
            vendorIds: [],
          };

          // Clear localStorage
          localStorage.removeItem('RFQ_FORM');

          this.$bvToast.toast(this.$t("detailedComparisonModal.resetOffers"), {variant: "success"});
        }
      });
    },
    fetchAddresses() {
      getCompanyAddresses(this.token, this.company.id).then(
          response => {
            this.savedAddresses = response;
          }
      )

    },
    handleSubmit() {
      if (!this.addressInput.trim()) return;

      if (this.formMode === "add") {
        this.addAddress();
      } else {
        this.updateAddress();
      }

      this.resetForm();

    },
    addAddress() {
      addAddressCompany(this.token, this.company.id, this.addressInput).then(
          response => {
              this.$bvToast.toast("Addres uğurla əlavə edildi", {variant: "success"});
              this.fetchAddresses();
          }
      );
    },
    updateAddress() {
      updateAddressCompany(this.token, this.editAddressId, this.addressInput).then(
          response => {
            this.$bvToast.toast("Addres uğurla dəyisdirildi", {variant: "success"});
            this.fetchAddresses();
          }
      )

    },
    deleteAddress(id) {
      if (!confirm("Addresi silməyə əminsiz?")) return;
      deleteAddressCompany(this.token, id).then(
          response => {
              this.$bvToast.toast("Addres silindi", {variant: "success"});
              this.fetchAddresses();
          }
      );
    },
    editAddress(address) {
      this.formMode = "edit";
      this.editAddressId = address.id;
      this.addressInput = address.address;
    },
    resetForm() {
      this.formMode = "add";
      this.editAddressId = null;
      this.addressInput = "";
    },
    selectAddress(address) {
      this.orderExtras.deliveryAddress = address.address;
      this.$bvModal.hide('modal-address-history');
    },
    findMissingSectors() {
      const selectedSectorIds = this.requestSectors.map(sector => sector.parent ? sector.parent.id : sector.id);

      const missingSectorIds = selectedSectorIds.filter(sectorId => {
        return !this.filteredVendors.some(vendor => {
              return vendor.sectors.some(sectorObj => sectorObj.sector.id === sectorId)
            }
        );
      });

      return this.requestSectors.filter(sector => missingSectorIds.includes(sector.parent ? sector.parent.id : sector.id));
    },
    getCountryCode(countryName) {
      const countries = this.$t('countries'); // Assuming this gives an object like { az: "Azerbaijan", ... }
      // Find the country code by searching through the countries object
      const countryCode = Object.keys(countries).find(key => countries[key] === countryName);
      return countryCode || null; // Return the country code if found, otherwise return null
    },
    updateCountryCodes() {
      this.countryCodes = this.selectedCountry.map(countryName => this.getCountryCode(countryName));
    },
    addSpecialRequirementToProduct() {
      if (this.editingProduct.specialRequirements.length < 5) {
        this.editingProduct.specialRequirements.push({text: '', mandatory: false});

      } else {
        alert('Yalniz 5 ədəd xususi tələb əlavə edə bilərsiz');
      }
    },
    removeSpecialRequirementFromProduct(index) {
      this.editingProduct.specialRequirements.splice(index, 1);
    },
    validateSelection() {

      if (this.requestType === "PQT" && (this.autoWinner === null || this.autoWinner === false)) {
        // No checkbox is selected, show an error or prevent form submission
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newRFQRequest.kotirovkaMetodunuSein"),
          icon: 'error'
        })
        return false;
      }
      // Proceed with form submission or next steps
      return true;
    },
    toggleChecked(id) {
      const index = this.vendorIds.indexOf(id);
      if (index === -1) {
        this.vendorIds.push(id);
      } else {
        this.vendorIds.splice(index, 1);
      }
      this.allSelected = this.vendorIds.length === this.vendors.length;
    },
    selectAllVendors() {
      if (this.allSelected) {
        // If all are already selected, unselect all
        this.vendorIds = [];
      } else {
        // Otherwise, select all vendors
        this.vendorIds = this.vendors.map(v => v.verifiedCompany.id);
      }
      this.allSelected = !this.allSelected; // Toggle the flag
    },
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY')
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },
    openModal() {
      if (this.onlyVendors === 1) {
        return
      }
      if (this.requestSectors.length === 0) {
        this.showSectorError = true;
        this.onlyVendors = 0;
      } else if (this.filteredVendors.length === 0) {
        this.filteredVendorsError = true;
        this.onlyVendors = 0;
      } else if (this.forms.length !== 0) {
        this.$bvModal.show('modal-vendors')
      } else if (this.onlyVendors) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.sektorTedarukcu"),
          icon: 'warning',
          confirmButtonText: this.$t("companyFormEdit.yarat"),
          allowOutsideClick: true
        }).then((create) => {
          if (create.isConfirmed) {
            window.open('/dashboard/vendorManagement/forms', '_blank');
          }
        });
      }
    },
    closeModal() {
      this.$bvModal.hide('modal-vendors');
    },
    sectorSelected(sectors) {
      this.requestSectors = sectors;
      this.showSectorError = false;
      let sectorIds = this.requestSectors.map(s => {
        return s.parent ? s.parent.id : s.id;
      });
      getFormsBySectorIds(this.token, sectorIds).then(data => {
            this.forms = data;
          }
      );
      this.filteredVendors = this.filterVendorsBySectors(this.vendors, sectors);
      this.missingSectors = this.findMissingSectors();
      this.$bvModal.hide('modal-sector-selection');
    },
    filterVendorsBySectors(vendorsArray, sectorsArray) {
      const sectorIds = sectorsArray.map(sector => sector.parent ? sector.parent.id : sector.id); // Extract ids of sectors in the 2nd array
      return vendorsArray.filter(vendor => {
        return vendor.sectors.some(sector => sectorIds.includes(sector.sector.id));
      });
    },
    createRequest() {
      if (!this.validateSelection()) return;

      const sectors = this.requestSectors.map(s => s.id).join(',');

      if (this.rfqTerms < 1) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.qaydalariQebul"),
          icon: 'warning'
        });
        return;
      }

      let extras = {};
      if (this.requestType === 'PQT') {
        const winnerDeadlineFormatted =
            moment(this.orderExtras.winnerDeadline)
                .format('YYYY-MM-DD HH:mm:ss');
        extras = {
          version: "1.0.0",
          currency: this.orderExtras.currency,
          currencyRequired: this.orderExtras.currencyRequired,
          incoterms: this.orderExtras.incoterms,
          incotermsRequired: this.orderExtras.incotermsRequired,
          payment: this.orderExtras.payment,
          paymentRequired: this.orderExtras.paymentRequired,
          deliveryAddress: this.orderExtras.deliveryAddress,
          showBefore: this.orderExtras.showBefore,
          alternativeRequired: this.orderExtras.alternativeRequired,
          deliveryNeeded: this.orderExtras.deliveryNeeded,
          deliveryTimeNeeded: this.orderExtras.deliveryTimeNeeded,
          guarantyTime: this.orderExtras.guarantyTime,
          countryRequired: this.orderExtras.countryRequired,
          delivery: `${this.orderExtras.delivery}`,
          initialRequirementNotes: this.orderExtras.initialRequirementNotes,
          winnerDeadline: winnerDeadlineFormatted
        };
      }

      // əsas yoxlamalar
      if (
          this.requestTitle &&
          this.products.length > 0 &&
          this.requestDescription.length >= 20 &&
          sectors
      ) {
        createRequest(
            this.token,
            this.requestType,
            this.requestType,     // requestSubType indi eyni olduğu üçün birbaşa
            sectors,
            this.requestTitle,
            this.requestFiles,
            this.requestDescription,
            this.requestDeadline,
            this.requestIsPrivate,
            this.requestIsPersonalAllowed,
            this.onlyVerified,
            this.onlyVendors,
            JSON.stringify(extras),
            this.products,
            this.pollAnswerList,
            this.vendorIds,
            this.autoWinner,
            this.countryCodes
        ).then(data => {
          if (data.code === 200) {
            // — draft-i sil
            localStorage.removeItem('RFQ_FORM');
            // — formState-i ilkin vəziyyətə qaytar
            this.formState = {
              requestType: 'PQ',
              requestTitle: '',
              requestDescription: '',
              requestSectors: [],
              selectedCountry: [],
              requestDeadline: '',
              orderExtras: {
                currency: '',
                currencyRequired: '',
                deliveryNeeded: '',
                deliveryAddress: '',
                deliveryTimeNeeded: '',
                paymentRequired: '',
                guarantyTime: '',
                countryRequired: '',
                initialRequirementNotes: '',
              },
              products: [],
              requestFiles: [],
              requestIsPrivate: 0,
              requestIsPersonalAllowed: 0,
              onlyVerified: 0,
              onlyVendors: 0,
              rfqTerms: 0,
              autoWinner: null,
              vendorIds: [],
            };
            // redirect
            this.$router.replace('/dashboard/request/' + data.id);
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: data.message,
              icon: 'error'
            });
          }
        });
      }
      else {
        // qalan error halları...
        if (!sectors) {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("generalModal.noWorkingSectorWarning"),
            icon: 'error'
          });
        }
        else if (this.products.length < 1) {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("newAUCRequest.enAziBirMehsul"),
            icon: 'error'
          });
        }
        else if (this.requestDescription.length < 20) {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("newAUCRequest.soruSpesifikasiyasNAz20SimvoldanIbartOlmaldr"),
            icon: 'error'
          });
        }
        else {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("newAUCRequest.butunBolmeleri"),
            icon: 'error'
          });
        }
      }
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    getVendorList() {

      getVendorList(this.token).then((list) => {
        this.vendors = list;
      });

    },
    selectExcel() {
      window.document.getElementById('excelInput').click();
    },
    setExcel() {
      let currentFile = this.$refs.excelFile.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'excel', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.$refs.excelFile.value = '';
              this.uploadProgress = 100;
              if (response.data.code === 200) {


                createRequestFromExcel(this.token, response.data.path).then(data => {

                  if (data.code === 200) {


                    this.requestTitle = data.data.title;
                    this.requestDescription = data.data.description;
                    this.requestDeadline = data.data.deadline;
                    this.requestIsPrivate = data.data.private ? 1 : 0;

                    this.products = [];

                    data.data.products.forEach(p => {
                      this.products.push({
                        productType: p.type,
                        name: p.name,
                        note: p.description,
                        count: parseInt(p.count),
                        unit: p.unit,
                        photos: []
                      });
                    });

                    this.$swal({
                      title: this.$t("generalModal.successTitle"),
                      text: this.$t("newAUCRequest.melumatlarKocuruldu"),
                      icon: 'success'
                    })


                  } else if (data.code === 500) {
                    this.$swal({
                      title: this.$t("err"),
                      text: this.$t("newAUCRequest.fileFormatApprove"),
                      icon: 'error'
                    })
                  } else {
                    this.$swal({
                      title: `Error ${data.code}`,
                      text: `${data.message}`,
                      icon: 'error'
                    })
                  }

                })


              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {

              this.progress = 0;
              this.$swal({
                title: `Error`,
                text: "Could not upload the file! " + e,
                icon: 'error'
              })
            });

      } else {
        this.$swal({
          title: `Error`,
          text: "Photo upload is not supported on your browser",
          icon: 'error'
        })
      }
    },
    selectPhoto(index) {
      this.photoIndex = index;
      if (index > -1) {
        window.document.getElementById('fileInput').click();
      } else {
        window.document.getElementById('fileInputMultiple').click();
      }
    },
    deleteProductPhoto(photoIndex) {
      if (confirm(this.$t("general.fileDltConfirm"))) {
        this.editingProduct.photos.splice(photoIndex, 1);
      }
    },
    deleteFile(index) {
      if (confirm(this.$t("general.fileDltConfirm"))) {
        this.requestFiles.splice(index, 1);
      }
    },
    setPhoto() {
      if (window.File && window.FileReader && window.FileList && window.Blob) {
        let fileList = this.photoIndex > -1 ? this.$refs.file.files : this.$refs.fileMultiple.files;
        fileList.forEach(currentFile => {
          upload(this.token, 'requestPhoto', currentFile, event => {
            this.uploadProgress = Math.round((100 * event.loaded) / event.total);
          })
              .then(response => {
                this.$refs.file.value = null;
                this.uploadProgress = 100;
                if (response.data.code === 200) {

                  if (this.photoIndex > -1) {
                    // Initialize photos array if it doesn't exist
                    if (!this.editingProduct.photos) {
                      this.editingProduct.photos = [];
                    }
                    // Add the photo to the array if we haven't reached the limit of 6
                    if (this.editingProduct.photos.length < 6) {
                      this.editingProduct.photos.push(response.data.path);
                    } else {
                      this.$swal({
                        title: this.$t("generalModal.warningTitle"),
                        text: "Maximum 6 photos allowed per product",
                        icon: 'warning'
                      });
                    }
                  } else {

                    this.requestFiles.push({
                      id: 0,
                      path: response.data.path,
                      type: "request"
                    });

                  }

                } else {
                  this.$swal({
                    title: `Error ${response.data.code}`,
                    text: `${response.data.message}`,
                    icon: 'error'
                  })
                }
              })
              .catch((e) => {

                this.progress = 0;
                this.$swal({
                  title: `Error`,
                  text: "Could not upload the file! " + e,
                  icon: 'error'
                })
              });


        });
      } else {
        this.$swal({
          title: `Error`,
          text: "Photo upload is not supported on your browser",
          icon: 'error'
        })
      }
    },
    addNewProduct() {

      this.products.push({
        name: '',
        note: '',
        count: '',
        unit: '',
        photos: [], // Changed from photo: '' to photos: [] to support multiple photos
        specialRequirements: [] // Initialize an empty array for special requirements
      })

      this.editProduct(this.products.length - 1);
    },
    deleteProduct(index) {
      this.products.splice(index, 1)
    },
    editProduct(index) {
      this.editingProductIndex = index;
      this.editingProduct = JSON.parse(JSON.stringify(this.products[index]));
      this.$bvModal.show('modal-edit-product');
    },
    saveProduct() {
      this.editingProduct.specialRequirements = this.editingProduct.specialRequirements.filter(req => req.text.trim() !== '');
      this.products.splice(this.editingProductIndex, 1, this.editingProduct);
      this.$bvModal.hide('modal-edit-product');
      this.editingProductIndex = -1;
      this.editingProduct = null;
    },
    cancelSaveProduct() {
      let lastItem = this.products[this.editingProductIndex];
      if (lastItem.productType === '' || lastItem.name === '' || lastItem.count < 1 || lastItem.unit === '') {
        this.products.splice(this.editingProductIndex, 1);
      }
      this.$bvModal.hide('modal-edit-product');
      this.editingProductIndex = -1;
      this.editingProduct = null;
    },
    checkDeadline(value) {
      // Assuming `orderExtras.winnerDeadline` and `requestDeadline` are in the same format
      if (new Date(value) < new Date(this.requestDeadline)) {
        this.errorMessage = '* ' + this.$t("newAUCRequest.qalibinsecilmesiTez");
      } else {
        this.errorMessage = ''; // Clear the error message if the condition is not met
      }
    },
  }

}
</script>

<style lang="scss" scoped>
h4 {
  font-size: 18px;
  font-weight: bold;
}

.card {
  .card-body {
    padding: 40px;
    font-size: 14px;
    color: #5D6B82;

    h4 {
      font-size: 16px;
      color: #233656;
    }

    p {
      font-size: 14px;
    }

    label {
      color: #233656;
    }
  }
}

.requestFile {
  display: block;
  background: rgba(#DEE5EF, 0.3);
  padding: 3px 10px;
  margin: 6px 0;
  border-radius: 6px;
}

.product-table {
  border: none;
  border-collapse: separate;
  border-spacing: 0 10px;

  thead {
    border: none;
    font-size: 13px;

    tr {
      border: none;

      th {
        border: none;
        font-weight: 400;
        color: #8B95A6;
      }
    }
  }

  tbody {

    tr {
      &:not(.not-found) {
        padding: 10px;
        background: #F9FAFC;
        white-space: nowrap;
        margin: 10px 0;
        border-radius: 6px;
        overflow: hidden;

        .can-wrap {
          white-space: normal;
          word-break: break-word;
        }

        td {
          &:first-child {
            border-radius: 6px 0 0 6px;
          }

          &:last-child {
            border-radius: 0 6px 6px 0;
          }
        }
      }
    }
  }
}

.error-message {
  color: red;
}
.selectable-address {
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding: 5px; /* istəyə bağlı */
}

.selectable-address:hover {
  background-color: #0f37da; /* Bootstrap primary rəngi */
  color: #fff; /* mətnin oxunaqlılığını artırmaq üçün */
}

</style>
